module.exports = __webpack_public_path__ + "static/media/placeholder1.7e4a590a.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/placeholder1.jpg
// module id = 623
// module chunks = 0